/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S4_P2Inputs */

const en_guide_json_rest_api_s4_p2 = /** @type {(inputs: Guide_Json_Rest_Api_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When comparing API responses between environments (staging vs production) or before/after a code change, the <a href="/json-diff">JSON Diff</a> tool highlights exactly what changed.`)
};

const ko_guide_json_rest_api_s4_p2 = /** @type {(inputs: Guide_Json_Rest_Api_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`환경 간(스테이징 vs 프로덕션) 또는 코드 변경 전후의 API 응답을 비교할 때, <a href="/json-diff">JSON Diff</a> 도구가 정확히 무엇이 변경되었는지 표시합니다.`)
};

const ja_guide_json_rest_api_s4_p2 = /** @type {(inputs: Guide_Json_Rest_Api_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`環境間（ステージングと本番）やコード変更前後のAPIレスポンスを比較する場合は、<a href="/json-diff">JSON Diff</a>ツールが変更箇所を正確にハイライトします。`)
};

/**
* | output |
* | --- |
* | "When comparing API responses between environments (staging vs production) or before/after a code change, the <a href=\"/json-diff\">JSON Diff</a> tool highligh..." |
*
* @param {Guide_Json_Rest_Api_S4_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s4_p2 = /** @type {((inputs?: Guide_Json_Rest_Api_S4_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S4_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s4_p2(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s4_p2(inputs)
	return ja_guide_json_rest_api_s4_p2(inputs)
});